import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";
import { REVIEW } from "@/lib/site-data";

export default function Reviews() {
    return (
        <section
            id="reviews"
            data-testid="reviews-section"
            className="relative py-24 lg:py-36 bg-beige/60 grain"
        >
            <div className="max-w-5xl mx-auto px-5 lg:px-10">
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-100px" }}
                    transition={{ duration: 0.8 }}
                    className="text-center"
                >
                    <span className="eyebrow inline-flex items-center gap-3">
                        <span className="w-8 h-px bg-gold" />
                        Guest Reviews
                        <span className="w-8 h-px bg-gold" />
                    </span>

                    <div className="mt-10 relative">
                        <Quote
                            size={64}
                            strokeWidth={1}
                            className="text-gold/40 mx-auto mb-6"
                        />
                        <p className="font-serif text-2xl sm:text-3xl lg:text-4xl text-maroon leading-tight tracking-tight max-w-3xl mx-auto italic">
                            “{REVIEW.quote}”
                        </p>
                        <div className="mt-8 flex items-center justify-center gap-1">
                            {Array.from({ length: REVIEW.rating }).map((_, i) => (
                                <Star
                                    key={i}
                                    size={18}
                                    className="text-gold-dark fill-gold-dark"
                                />
                            ))}
                        </div>
                        <p className="mt-4 text-sm tracking-[0.2em] uppercase text-ink-muted">
                            — {REVIEW.author}
                        </p>
                    </div>
                </motion.div>

                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 0.8, delay: 0.2 }}
                    className="mt-20 grid grid-cols-2 md:grid-cols-4 gap-px bg-gold/30 border border-gold/30 max-w-3xl mx-auto"
                    data-testid="stats-grid"
                >
                    {[
                        { v: "4,700+", l: "Happy guests" },
                        { v: "5.0", l: "Average rating" },
                        { v: "7", l: "Therapies" },
                        { v: "Daily", l: "Open every day" },
                    ].map((s) => (
                        <div
                            key={s.l}
                            className="bg-cream p-6 lg:p-8 flex flex-col items-center text-center"
                        >
                            <div className="font-serif text-3xl lg:text-4xl text-maroon">
                                {s.v}
                            </div>
                            <div className="text-[0.65rem] tracking-[0.22em] uppercase text-ink-muted mt-2">
                                {s.l}
                            </div>
                        </div>
                    ))}
                </motion.div>
            </div>
        </section>
    );
}
